import React from 'react';
import Select from 'react-select';

const ReclaimSelect = (props) => {
    const { ...rest } = props;
    return <Select className="r-select" classNamePrefix="r-select" {...rest} />;
};

export default ReclaimSelect;
